export const ROLE = {
  SUSTECH    : 1,
  NON_SUSTECH: 2,
  ADMIN      : 3,
  USER       : 4,
  APPROVAL   : 5
};
